export default "__VITE_ASSET__4yiHWIwu__"